var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6787 8.219L13.4199 0.959983C13.2127 0.752774 12.9365 0.639038 12.642 0.639038C12.3472 0.639038 12.0712 0.752938 11.864 0.959983L11.205 1.6192C10.9979 1.82608 10.8838 2.10241 10.8838 2.39705C10.8838 2.69152 10.9979 2.97717 11.205 3.18405L15.4397 7.42808H1.98579C1.3792 7.42808 0.899902 7.90296 0.899902 8.50971V9.44166C0.899902 10.0484 1.3792 10.5712 1.98579 10.5712H15.4877L11.2051 14.8389C10.9981 15.0461 10.884 15.3149 10.884 15.6096C10.884 15.9039 10.9981 16.1766 11.2051 16.3837L11.8642 17.0407C12.0714 17.248 12.3474 17.3609 12.6422 17.3609C12.9367 17.3609 13.2128 17.2465 13.42 17.0393L20.6789 9.78042C20.8866 9.57256 21.0008 9.29508 21 9.00012C21.0007 8.70418 20.8866 8.42654 20.6787 8.219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow_white.ddcc4023a1ad455e8c356c8445410f0f.svg";
export { ForwardRef as ReactComponent };